import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../lib/ui";

const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const initials = (name) =>
  name.split(/\s+/).slice(0, 2).map((w) => w[0]).join("");

/** Named people: the trustee, and the team on the ground in Kenya. Empty groups render nothing. */
export const People = ({ group }) => {
  if (!group?.members?.length) return null;
  return (
    <div className="mt-20" data-testid={`people-${slug(group.heading)}`}>
      <p className="eyebrow">{group.heading}</p>
      <h2 className="display-2 mt-4 max-w-3xl">{group.heading}</h2>
      <p className="body-copy mt-5 max-w-3xl">{group.intro}</p>
      <div className="mt-10 grid gap-px bg-zinc-800 sm:grid-cols-2">
        {group.members.map((m) => (
          <Reveal key={m.name}>
            <article className="flex h-full flex-col gap-5 bg-black p-6 sm:flex-row md:p-7" data-testid={`person-${slug(m.name)}`}>
              <span className="flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden bg-white/[0.04] font-display text-2xl font-bold text-white/40">
                {m.photo_url ? (
                  <img
                    src={m.photo_url}
                    alt={m.name}
                    loading="lazy"
                    data-testid={`person-photo-${slug(m.name)}`}
                    className="h-full w-full object-cover object-top"
                  />
                ) : (
                  initials(m.name)
                )}
              </span>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-display text-lg uppercase leading-tight tracking-tight text-white md:text-xl">
                    {m.name}
                  </h3>
                  {m.status ? (
                    <span className="mono border border-ochre/50 px-2 py-1 text-[0.5rem] uppercase tracking-[0.16em] text-ochre">
                      {m.status}
                    </span>
                  ) : null}
                </div>
                <p className="mono mt-2 text-[0.55rem] uppercase leading-relaxed tracking-[0.16em] text-zinc-400">
                  {m.role}
                </p>
                {m.bio ? <p className="mt-3 text-sm leading-relaxed text-zinc-400">{m.bio}</p> : null}
                {m.profile ? (
                  <Link
                    to={m.profile}
                    data-testid={`person-profile-${slug(m.name)}`}
                    className="mono mt-4 inline-flex items-center gap-1.5 text-[0.55rem] uppercase tracking-[0.16em] text-ochre hover:text-white"
                  >
                    Their player profile <ArrowUpRight size={11} />
                  </Link>
                ) : null}
                {m.source ? (
                  <a
                    href={m.source}
                    target="_blank"
                    rel="noreferrer"
                    data-testid={`person-source-${slug(m.name)}`}
                    className="mono mt-4 inline-flex items-center gap-1.5 text-[0.55rem] uppercase tracking-[0.16em] text-ochre hover:text-white"
                  >
                    Her coaching record <ArrowUpRight size={11} />
                  </a>
                ) : null}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  );
};
